<template>
  <SensorListPopup :sensor-list="addableMarkers"/>
  <RoomPopup :last-opened="this.lastOpenedRoom"></RoomPopup>

  <div class="container-fluid">

    <div class="row header-panel nav-alt">
      <div class="col-3 left_side">
        <div class="login_logo_wrapper">
          <span>v2.0</span>
        </div>
      </div>
      <div class="col-9 right_side">
        <NavItem/>
      </div>
    </div>


    <div class="row content-panel d-flex justify-content-between">

      <div class="d-none d-md-block col-3 content-side">
        <LeftSideITem ref="leftSide"/>
      </div>
      <div class="col-12 col-md-9 content">
        <!-- Mobile Tabs Navigation -->
        <ul class="nav nav-tabs d-md-none" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="mobileTab === 'warehouses' ? 'active' : ''" @click="mobileTab = 'warehouses'" type="button">
              საწყობები
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link" :class="mobileTab === 'sensors' ? 'active' : ''" @click="mobileTab = 'sensors'" type="button">
              სენსორები
            </button>
          </li>
        </ul>
        
        <!-- Mobile Warehouse View -->
        <div v-if="mobileTab === 'warehouses'" class="d-md-none p-3">
          <LeftSideITem ref="leftSideMobile"/>
        </div>
        
        <!-- Desktop & Mobile Sensor View -->
        <div v-if="mobileTab === 'sensors' || !isMobile()" class="d-flex flex-column content-header bread-area m-0 ps-1 border-bottom">
          <BreadCrumb :crumbs="getBreadCrumbs"/>

          <div class="d-flex justify-content-between  toolbar-panel">
<!--            <div class="d-flex justify-content-between align-items-center button-switch" >-->
<!--              <button type="button" :class="activeToggle === 'table' ?'active-toggle' : '' " @click="toggleButton('table')">-->
<!--                <img src="/svgs/list.svg" alt="">-->
<!--                ცხრილი-->
<!--              </button>-->
<!--              <button type="button" :class="activeToggle === 'map' ?'active-toggle' : '' " @click="toggleButton('map')">-->
<!--                <img src="/svgs/map.svg" alt="">-->
<!--                რუკა-->
<!--              </button>-->
<!--            </div>-->
            <div class="action-buttons d-flex ">
            <template v-if="activeToggle === 'table'">
              <div class="d-flex align-items-center action-buttons">
                <!--                  <button type="button" class="btn btn-brand">-->
                <!--                    <img src="/svgs/edit.svg" alt="">-->
                <!--                    ქმედება-->
                <!--                  </button>-->
                <!--                  <button type="button" class="btn btn-brand">-->
                <!--                    <img src="/svgs/filter.svg" alt="">-->
                <!--                    ფილტრი-->
                <!--                  </button>-->
              </div>
            </template>

            <template v-else>

                <transition name="fade" >
                  <button class="btn btn-add extra" @click="saveEditMap"  v-if="this.sensorEditingMode">
                    შენახვა
                  </button>
                </transition>

                <div v-if="markerTemplate">
                  <OnClickOutside @trigger="closeSensorManagerDropdown">
                  <button type="button" class="btn btn-brand" @click.prevent="toggleSensorManagerDropdown">
                    <img src="/svgs/filter.svg" alt="">
                    ფილტრი
                  </button>
                      <div class="sensor-toolbar toolbar-2" v-if="this.sensorManagerDropdown">
                        <ul>
                          <li>
                            <input type="checkbox" name="description" id="description" v-model="this.sensorShowingDescription" >
                            <label for="description">სახელი</label>
                          </li>
                          <li>
                            <input type="checkbox" name="name" id="name" v-model="this.sensorShowingName" >
                            <label for="name">სერიული ნომერი</label>
                          </li>
                          <li>
                            <input type="checkbox" name="controller" id="controller" v-model="this.sensorShowingController">
                            <label for="controller">კონტროლერი</label>
                          </li>
                          <li>
                            <input type="checkbox" name="measurment" id="measurment" v-model="this.sensorShowingMeasurments" >
                            <label for="measurment">მაჩვენებელი</label>
                          </li>
                        </ul>
                      </div>
                  </OnClickOutside>
                </div>
                &nbsp;

            </template>
<!--            <OnClickOutside @trigger="closeSensorDropdown">-->
<!--              <button type="button" class="btn btn-brand" @click="toggleSensorDropdown">-->
<!--                <img src="/svgs/edit.svg" alt="">-->
<!--                რედაქტირება-->
<!--              </button>-->
<!--              <div class="sensor-toolbar" v-if="this.sensorDropdown">-->
<!--                <ul>-->
<!--                  <li @click.prevent="openAddableSensorMarkers" data-bs-toggle="modal" data-bs-target="#sensorListModal">-->
<!--                    <img src="/svgs/add2-before.svg" alt="">-->
<!--                    სენსორის დამატება-->
<!--                  </li>-->
<!--                  <li @click.prevent="enterEditingMode" disabled>-->
<!--                    <img src="/svgs/editv2.svg" alt="">-->
<!--                    სენსორის ედიტირება-->
<!--                  </li>-->
<!--                  <li @click="removeImage" v-if="this.lastOpened.activeRoom.image">-->
<!--                    <img src="/svgs/remove.svg" alt="">-->
<!--                    რუკის წაშლა-->
<!--                  </li>-->
<!--                  <li @click="chooseFiles()" v-if="!this.lastOpened.activeRoom.image">-->
<!--                    <input id="fileUpload"  @input="mapFileChosen" type="file" hidden>-->
<!--                    <img src="/svgs/map-black.svg" alt="">-->
<!--                    რუკის დამატება-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </OnClickOutside>-->
          </div>
          </div>
        </div>
        
        <!-- Content Body - Show for sensors tab on mobile or always on desktop -->
        <div class="content-body" v-if="mobileTab === 'sensors' || !isMobile()">
          <transition name="fade" mode="in-out">
            <div >
              <div class="d-block d-md-none responsive-sensor-container" v-if="activeToggle === 'table' &&sensors && sensors.sensors && sensors.sensors.length">
                <ul class="sensor-list-responsive" >
                  <li v-for="sensor in sensors.sensors" :key="sensor.id" @click="navigateToReports(sensor)">
                    <div class="d-flex justify-content-between each-responsive-sensor">
                      <div class="sensor-name">
                        {{ sensor.name }}
                      </div>
                      <div class="sensor-data">
                        <template v-if="sensor.sensor_data">
                          <img src="/svgs/temp-green.svg" alt=""> {{ sensor.sensor_data.tempo ? sensor.sensor_data.tempo : '--.--' }} ℃
                          <img src="/svgs/humidity-green.svg" alt=""> {{sensor.sensor_data.humidity ? parseInt(sensor.sensor_data.humidity) : '--.--'}} %
                        </template>
                        <template v-else>
                          არ აქვს გადმოცემა
                        </template>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="d-none d-md-block">
                <table class="table table-responsive" v-if="activeToggle === 'table' &&sensors && sensors.sensors && sensors.sensors.length">
                  <thead>
                  <tr>
                    <th style="width: 300px;" @click.prevent="sortBy('name')">
                      სერიული ნომერი
                      <template v-if="isFilteredBy('name')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 300px;" @click.prevent="sortBy('description')">
                      სახელი
                      <template v-if="isFilteredBy('description')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 190px;" @click.prevent="sortBy('room')">
                      ლოკაცია
                      <template v-if="isFilteredBy('room')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 90px;" @click.prevent="sortBy('sensor_data.tempo','sensor_data')">
                      <img src="/svgs/temp-green.svg" alt="">
                      <template v-if="isFilteredBy('sensor_data.tempo')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 90px;" @click.prevent="sortBy('sensor_data.humidity','sensor_data')">
                      <img src="/svgs/humidity-green.svg" alt="">
                      <template v-if="isFilteredBy('sensor_data.humidity')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 90px;" @click.prevent="sortBy('sensor_data.battery_proc','sensor_data')">
                      <img src="/svgs/battery.svg" alt="">
                      <template v-if="isFilteredBy('sensor_data.battery_proc')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>
                    <th style="width: 300px" @click.prevent="sortBy('last_measure')">
                      ბოლო გადმოცემა
                      <template v-if="isFilteredBy('last_measure')">
                        <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                      </template>
                    </th>

                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="sensor in sensors.sensors" :key="sensor.id" @mouseover="sensorHovered(sensor)" @mouseleave="sensorHoverExit">
                    <td @click="navigateToReports(sensor)" class="font-roboto">
                      <div :class="'hover-overlay sensor-'+sensor.id">
                        <button class="d-flex align-items-center justify-content-center btn btn-brand-chart" >
                          <img src="/svgs/chart.svg" alt="">
                        </button>
                      </div>
                      {{ sensor.name + ' - ' + sensor.serialnumber }}
                    </td>
                    <td  class="table-text-left">
<!--                      <OnClickOutside @trigger="enterSensorNameEditingMode(sensor,true)">-->
                        <span v-on:focusout="enterSensorNameEditingMode(sensor,true)"  v-on:keydown.enter.prevent="enterSensorNameEditingMode(sensor, true)"
                               :contenteditable="isEditingSensor(sensor.id)"
                               ref="descriptionEditale"
                               :data-id="sensor.id"
                               class="p-10 sensor-name-span" :id="'sensor-name-id-'+sensor.id"
                        >
                          {{ sensor.description }}
                        </span>
                        <img src="/svgs/edit2.svg" class="pencil-image" v-if="isHoveredSensor(sensor.id)" @click.prevent="enterSensorNameEditingMode(sensor)" alt="" >
                        <img src="/svgs/edit2.svg" style="visibility: hidden" >
<!--                      </OnClickOutside>-->
                    </td>
                    <td @click="navigateToReports(sensor)">
                      {{ sensor.room }}
                    </td>

                    <template v-if="sensor.sensor_data">
                      <td class="font-roboto" @click="navigateToReports(sensor)">
                        {{ sensor.sensor_data.tempo ? sensor.sensor_data.tempo : '--.--' }} ℃
                      </td>
                      <td class="font-roboto" @click="navigateToReports(sensor)">
                        {{sensor.sensor_data.humidity ? parseInt(sensor.sensor_data.humidity)  : '--.--'}} %
                      </td>
                      <td class="font-roboto" @click="navigateToReports(sensor)">
                        {{ sensor.sensor_data.battery_proc ?  parseInt(sensor.sensor_data.battery_proc) : '--.--'}} %
                      </td>
                    </template>
                    <template v-else>
                      <td colspan="3">
                        არ აქვს გადმოცემა
                      </td>
                    </template>
                    <td>
                      <template v-if="sensor.sensor_data">
						<span :class="calculateMeasure(sensor.last_measure).color">
							{{ calculateMeasure(sensor.last_measure).finalString }}
						</span>
                      </template>
                    </td>
<!--                    <td>-->
<!--                      <div class="hover-overlay-w position-right ">-->
<!--                        <img src="/svgs/times.svg"   @click.prevent="removeSensor(sensor)" alt="">-->
<!--                      </div>-->
<!--                    </td>-->
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="map-container" id="map" v-if="activeToggle === 'map'">
                <div v-if="!this.lastOpened.activeRoom.image" class="d-flex flex-column justify-content-center align-items-center empty-room-img-holder"
                     v-bind="getRootProps()">
                  <input v-bind="getInputProps()" />
                  <img src="/svgs/drop.svg" alt="">
                  ფოტო ატვირთეთ ან ჩააგდეთ
                </div>

              </div>

            </div>
          </transition>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import NavItem from "@/components/partials/NavItem";
import LeftSideITem from "@/components/partials/LeftSideItem";
import moment from "moment";
import  "leaflet/dist/leaflet"
import BreadCrumb from "@/components/partials/BreadCrumb";
import SensorListPopup from "@/components/partials/reusable/SensorListPopup";
import { OnClickOutside } from '@vueuse/components'
import { ref } from "vue";
import RoomPopup from "@/components/partials/reusable/RoomPopup";
import {useDropzone} from "vue3-dropzone";
import Helper from "@/helpers/Helper";
import config from '@/config.json'

export default {
  name: "DashboardItem",
  components:{
    SensorListPopup,
    BreadCrumb,
    LeftSideITem,
    NavItem,
    OnClickOutside,
    RoomPopup
  },
  computed: {
    markerTemplate(){

      this.bindMarker()

      return this.$store.state.user.markerTemplate
    },
    lastTransmissions() {
      return this.$store.state.warehouse.lastTransmissions;
    },
    warehouses(){
      return this.$store.state.warehouse ? this.$store.state.warehouse.list.data : null
    },
    sensors(){
      return this.$store.state.warehouse ? this.$store.state.warehouse.sensors : null
    },
    getBreadCrumbs(){
      let crumbs = []
      if (this.lastOpened.warehouse){

        const crumb = {"name":this.lastOpened.warehouse.name,  "offcanvas": "#offcanvasExample"}

        if (this.lastTransmissions[this.lastOpened.warehouse.controllers[0]?.imei]?.datestamploc < 0.1){
          crumb.class = 'bg-online rounded text-center text-white'
          crumb.style = ' padding: 10px 10px 5px 10px; '
        }

        crumbs.push(crumb)
        if (this.lastOpened.activeRoom){
          crumbs.push({"name":this.lastOpened.activeRoom.name, "active":true})
        }
        return crumbs
      }
      return []
    },
    fetchedMarkers(){
      return this.$store.state.warehouse ? this.$store.state.warehouse.markers : null
    },
    addableMarkers(){
      return this.$store.state.warehouse ?  this.$store.state.warehouse.addableMarkers.data : null
    },
  },
  methods:{
    bindMarker(){

      if (this.$store.state.user.markerTemplate != null){
        console.log('binding marker')

        this.sensorShowingDescription = this.$store.state.user.markerTemplate.sensorShowingDescription
        this.sensorShowingName = this.$store.state.user.markerTemplate.sensorShowingName
        this.sensorShowingController = this.$store.state.user.markerTemplate.sensorShowingController
        this.sensorShowingMeasurments =this.$store.state.user.markerTemplate.sensorShowingMeasurments
      }
    },
    pollSensorData() {
      //means if sensor list loaded
        this.polling = setInterval(() => {
          if (this.lastOpened){
            const roomIds = this.lastOpened.activeRoom ? this.lastOpened.activeRoom.id : this.lastOpened.warehouse.warehouse_rooms.map((item) => item.id)
            this.$store.dispatch('warehouse/getWarehouseRoomSensors',roomIds, true)
          }
        }, 8400)
    },
    mapFileChosen(e){
      let file =  e.target.files[0]
      const formData = new FormData(); // pass data as a form
      formData.append('file', file)
      formData.append('roomId', this.lastOpened.activeRoom.id)
      this.$store.dispatch('warehouse/updateRoomMapPicture', formData).then(
          ()  => {
            this.lastOpened.activeRoom.image = this.$store.state.warehouse.room.data.room.image
            this.fetchSensorPins()

          }
      )
    },
    chooseFiles(){
      document.getElementById("fileUpload").click()
    },
    removeImage(){
      this.$store.dispatch('warehouse/removeRoomPicture', this.lastOpened.activeRoom.id).then(
          () => {
            this.lastOpened.activeRoom.image = null
            if (this.map) this.map.remove()
            this.map = null
          }
      )
    },
    removeSensor(sensor){
      this.$swal({
        title: '',
        text: "გსურთ სენსორის წაშლა?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#F3F7FE',
        cancelButtonColor: '#F47B7A',
        confirmButtonText: 'დიახ, წავშალოთ',
        cancelButtonText: 'გაუქმება'
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading =true
          this.$store.dispatch('warehouse/removeMarkerFromRoom',sensor.id).then(
              () => {
                this.loading = false

                this.$swal({
                  title: '',
                  text: 'სენსორი წაიშალა',
                  confirmButtonText: 'დახურვა',
                })

              }
          )
        }
      })
    },
    isFilteredBy(key){
      if (this.filteringState.key === key){
        return true
      }
      return false
    },
    sortBy(key, nested = false){
      this.changeFilterState(key)

      let splitedKey = key.split('.')[key.split('.').length - 1]

      this.sensors.sensors.sort((a,b)=>{
        let comparableA = a[splitedKey]
        let comparableB = b[splitedKey]

        if (nested){
          let path = nested.split('.')
          let tmpObj  = null
          let tmpObjB = null
          for (let i = 0 ; i < path.length; i++){
            if (i === 0){
              tmpObj = a[path[0]]
              tmpObjB = b[path[0]]
              continue
            }
            tmpObj = tmpObj[path[i]]
            tmpObjB = tmpObjB[path[i]]

          }
          if (tmpObj && tmpObjB){
            comparableA = tmpObj[splitedKey]
            comparableB = tmpObjB[splitedKey]
          }
        }
        if (this.filteringState.ordering === 'DESC'){
          return  comparableA > comparableB ? 1 : -1
        }else{
          return  comparableA < comparableB ? 1 : -1
        }
      })
    },
    changeFilterState(key){
      if (this.filteringState.key === key){
        this.filteringState.ordering = this.filteringState.ordering ===  'ASC' ? 'DESC' : 'ASC'
        return
      }
      this.filteringState.key = key
      this.filteringState.ordering = 'DESC'
    },
    getIconByOrdering(){
      let icon = 'sort-down'
      if (this.filteringState.ordering === 'DESC'){
        icon = 'sort-up'
      }
      return icon
    },
    activeRoom(lastOpened){
      this.lastOpened = lastOpened
    },
    displayMarkers(){
      this.fetchedMarkers.data.sensors.forEach(item => this.addMarkerToMap(item))
    },
    toggleButton: function (toggleTo) {
      if (this.lastOpened.roomSelected){
        this.activeToggle = toggleTo;
        if (toggleTo === "map") {
          this.fetchSensorPins()
        }
      }else {
        console.log("before map fetching we need room")
      }
    },
    fetchSensorPins(){
      if (this.activeToggle === 'map'){

        setTimeout(
            () => {
              this.initMap()
              if (this.map){
                this.$store.dispatch('warehouse/roomMarkerList', `${this.lastOpened.activeRoom.id}`).then(
                    () => this.displayMarkers()
                )
              }
            }
        )
      }
    },
    addDeleteListenerToMarkers(){
      //listener for remove trigger
      setTimeout(()=> {
        const proccessClickEvent = (event) => {
          let sensorId = event.getAttribute('data-id')
          this.$store.dispatch('warehouse/removeMarkerFromRoom',sensorId)
              .then(
                  () => {
                    this.map.eachLayer((item) => {
                      if (parseInt(item.options.sensorId) === parseInt(sensorId)){
                        this.map.removeLayer(item)
                      }
                    })
                  }
              )
        }
        let markerRemoveContainer = document.getElementsByClassName('tooltip-remove-sensor')
        for (let i = 0; i < markerRemoveContainer.length; i++){
          markerRemoveContainer[i].removeEventListener('click', function (){})
          markerRemoveContainer[i].addEventListener('click',function (){
            proccessClickEvent(this)
          })
        }
      },200)
    },
    toggleSensorDropdown(){
      this.sensorDropdown = !this.sensorDropdown;
    },
    toggleSensorManagerDropdown(){
      this.sensorManagerDropdown = !this.sensorManagerDropdown
    },
    closeSensorDropdown(){
      this.sensorDropdown = false
    },
    closeSensorManagerDropdown(){
      this.sensorManagerDropdown = false
    },
    openAddableSensorMarkers(){
      let imeis = this.lastOpened.warehouse.controllers.map(it => {
        return it.imei
      })
      this.sensorDropdown = false
      this.$store.dispatch('warehouse/addableMarkerList', imeis)
    },
    enterEditingMode(exit = false){
      this.sensorEditingMode = !this.sensorEditingMode

      if (this.sensorEditingMode){
        // markerParams.draggable = 'true'
        this.map.eachLayer((item) => {
          if (item.dragging){
            item.dragging.enable()
          }
        })

        this.addDeleteListenerToMarkers()

      }else{
        this.map.eachLayer((item) => {
          if (item.dragging){
            item.dragging.disable()
          }
        })
      }

      if (exit){
        this.sensorDropdown = false
      }else{
        this.toggleSensorDropdown()
      }
      this.reRenderPopups()
    },
    getMeasureString(){

    },
    calculateMeasure(dateString){
      let now = moment()
      let measureDate = moment(dateString)
      let duration = moment.duration(now.diff(measureDate));
      let hours = duration.asHours();

      return Helper.measureString(hours);
          // .replace('დღის წინ', ' დღე')
          // .replace('რამდენიმე წამის წინ', ' 1 წმ')
          // .replace('წუთის წინ', ' წთ')

    },
    navigateToReports(sensor){
      this.$store.dispatch('warehouse/setSelectedSensor',sensor).then(
          () => this.$router.push(`/sensor/reports/${sensor.id}`)
      )
    },
    enterSensorNameEditingMode(sensor, outsideClick = false){
      let newname = document.getElementById('sensor-name-id-'+sensor.id)

      if (outsideClick){
        if (newname && sensor.description !== newname.innerHTML){
          this.$store.dispatch('warehouse/updateSensorName', {
            id: sensor.id,
            name: newname.innerHTML
          }).then( ()=> sensor.description = newname.innerHTML )

        }
        this.sensorNameEditing = false
      }else{
        if(this.sensorNameEditing === sensor.id){
          this.$store.dispatch('warehouse/updateSensorName', {
            id: sensor.id,
            name: newname.innerHTML
          })
          this.sensorNameEditing = false;
        }else{
          this.sensorNameEditing = sensor.id
          this.$nextTick(() => {
            let currentRef = this.$refs.descriptionEditale.filter( (item) => {
              return parseInt(item.getAttribute('data-id')) === sensor.id
            } )
            if(currentRef.length) currentRef[0].focus()
          });
        }

      }
    },
    isEditingSensor(id){
      if (this.sensorNameEditing === id){
        return true
      }
      return false
    },
    sensorHovered(sensor){
      this.sensorHoveredState = sensor.id
    },
    sensorHoverExit(){
      this.sensorHoveredState = false
    },
    isHoveredSensor(id){
      if (this.sensorHoveredState === id){
        return true
      }
      return false
    },
    saveEditMap(){
      this.enterEditingMode(true)
      let data = {sensors:[]}
      this.map.eachLayer((item) => {
        if (item.dragging){
          item.dragging.disable()
          let position = item.getLatLng()
          data.sensors.push({
            map_y: position.lat,
            map_x: position.lng,
            sensorid:  item.options.sensorId,
            roomid: this.lastOpened.activeRoom.id,
          })
        }
      })
      this.$store.dispatch('warehouse/updateRoomMapSensorMarkers', data)
    },
    generatePopup(sensor , extraClass = '', contentOnly = false){
      let deleteHtml = 'hidden'
      if (this.sensorEditingMode){
        deleteHtml = 'visible'
      }

      let sensorNameDiv = `<hr/><div>${ sensor ? sensor.name : '-' }</div>`
      let sensorDescriptionDiv = `<hr/><div>${ sensor && sensor.description  !== null ? sensor.description  : '-' }</div>`

      if (this.sensorShowingDescription === "false" || !this.sensorShowingDescription){
        sensorDescriptionDiv = ''
      }

      if (this.sensorShowingName === "false" || !this.sensorShowingName ){
        sensorNameDiv = ''
      }
      let controllerDiv = `<hr/><div class="tooltip-transmission"> ${sensor ? sensor.imei : '-' }</div>`
      if (this.sensorShowingController === "false" || !this.sensorShowingController){
        controllerDiv = ''
      }

      let measurmentDiv = `
      <div class="text-center tooltip-transmission font-roboto" >
                    <img src="/svgs/temp-green.svg" alt="" width="20" height="20" /> ${sensor && sensor.sensor_data && sensor.sensor_data.tempo !== null ? sensor.sensor_data.tempo + '℃' : '-' }
                    <img src="/svgs/humidity-green.svg" alt="" width="20" height="20" /> ${sensor && sensor.sensor_data && sensor.sensor_data.humidity !== null ? parseInt(sensor.sensor_data.humidity) + '%' : '-' }
                    <img src="/svgs/battery.svg" alt="" width="20" height="20" /> ${sensor && sensor.sensor_data && sensor.sensor_data.battery_proc !== null ? parseInt(sensor.sensor_data.battery_proc) + '%' : '-' }
      </div>
      `
      if (this.sensorShowingMeasurments === "false" || !this.sensorShowingMeasurments){
        measurmentDiv = ''
      }

      let popupContent = `
        <div class="tooltip-sensor-container">
               <div  class="tooltip-remove-sensor ${deleteHtml} ${extraClass}" data-id="${sensor ? sensor.id : null}"><img src="/svgs/trash-red.svg"/> </div>
               <div class="d-flex justify-content-around flex-column align-items-center tooltip-sensor-panel">
                 ${measurmentDiv}
                 ${controllerDiv}
                 ${sensorNameDiv}
                 ${sensorDescriptionDiv}
               </div>
        </div>
        `


      if (contentOnly){
        return popupContent
      }

      // eslint-disable-next-line no-undef
      let popup = L.popup({ closeOnClick: false , autoClose: false})
          .setContent(popupContent);

      return popup
    },
    reRenderPopups(){
      if (this.map){
        this.map.eachLayer((item) => {
          if (item._popup){
            let sensor = this.findSensorInActiveRoom(item.options.sensorId)
            item._popup.setContent(
                this.generatePopup(sensor,'',true)
            )

            if (!this.sensorShowingName && !this.sensorShowingController && !this.sensorShowingMeasurments && !this.sensorShowingDescription){
              // item._popup.removeFrom(this.map)
            }else{
              item._popup.addTo(this.map)
            }
          }
        })
      }
    },
    addMarkerToMap(sensor , extraClass = '', isDraggable = false){
      //remove it from addable marker list
      if (this.addableMarkers){
        let index = this.addableMarkers.sensors.findIndex(item => item.id === sensor.id);
        this.addableMarkers.sensors.splice(index, 1);
      }

      if (this.map !== null && this.activeToggle === "map"){
        // eslint-disable-next-line no-undef
        let sol = L.latLng([
            sensor.room_to_sensor ? parseFloat(sensor.room_to_sensor.map_y) : 0.0,
            sensor.room_to_sensor ? parseFloat(sensor.room_to_sensor.map_x) : 0.0]
        );
        // eslint-disable-next-line no-undef
        let marker = L.marker(sol, {
          draggable: 'true',
          sensorId: sensor ? sensor.id : 0,
          icon: this.markerIcons["default"]
        }).addTo(this.map);

        if (!isDraggable) marker.dragging.disable()

        let newpopup = this.generatePopup(sensor, extraClass)

        marker.bindPopup(newpopup, {
          closeButton: false
        }).openPopup()

        marker.on('dragend', function(event){
          let marker = event.target;
          let position = marker.getLatLng();
          // eslint-disable-next-line no-undef
          marker.setLatLng(new L.LatLng(position.lat, position.lng),{draggable:'true'});
          marker.openPopup()
        });
      }
      else if (this.activeToggle === "table"){
        this.$store.dispatch('warehouse/updateRoomMapSensorMarkers', {
            'sensors': [{
              map_y: 0.0,
              map_x: 0.0,
              sensorid:  sensor.id,
              roomid: this.lastOpened.activeRoom.id,
            }]
        })
      }
    },

    initMap(){
      if (document.getElementById('map')){
        if(this.lastOpened.activeRoom.image){
          if (this.map !== null){
            this.map.invalidateSize()
            this.map.off()
            this.map.remove()
          }
          // eslint-disable-next-line no-undef
          let map = L.map('map', {
            // eslint-disable-next-line no-undef
            crs: L.CRS.Simple,
            minZoom: -3
          });
          map.setView([320, 680], 0);
          let bounds = [[0, 0], [600, 1200]];
          // eslint-disable-next-line no-undef
          L.imageOverlay( config.BASE_URL + `/images/rooms/${this.lastOpened.activeRoom.id}/${this.lastOpened.activeRoom.image}`, bounds).addTo(map);
          this.map = map
        }
        else{
          if (this.map){
            this.map.invalidateSize()
            this.map.off()
            this.map.remove()
            this.map = null
          }
          //if image removed ask for adding photo
        }
      }
    },
    findSensorInActiveRoom(sensorId){
      let currentSensor = this.fetchedMarkers.data.sensors.filter(it => {
        return it.id === sensorId
      })

      return currentSensor.length > 0 ? currentSensor[0] : null
    },
    isMobile(){
      return window.innerWidth < 768
    }
  },
  data(){
    const saveFiles = (files) => {
      const formData = new FormData(); // pass data as a form
      formData.append('file', files[0])
      formData.append('roomId', this.lastOpened.activeRoom.id)
      this.$store.dispatch('warehouse/updateRoomMapPicture', formData).then(
          ()  => {
            this.lastOpened.activeRoom.image = this.$store.state.warehouse.room.data.room.image
            this.fetchSensorPins()
          }
      )
    };

    function  onDrop(acceptedFiles) {
      saveFiles(acceptedFiles);
    }

    const { getRootProps, getInputProps, ...rest } = useDropzone({onDrop});


    return {
      getRootProps,
      getInputProps,
      ...rest,
      activeToggle: "table",
      mobileTab: "sensors",
      lastOpened:'',
      lastOpenedRoom: ref(null),
      sensorDropdown: ref(false),
      sensorManagerDropdown: ref(false),
      sensorShowingDescription: ref(true ),
      sensorShowingName: ref(true ),
      sensorShowingController: ref( true),
      sensorShowingMeasurments: ref( true),
      sensorNameEditing: ref(false),
      sensorEditingMode: false,
      sensorHoveredState: ref(false),
      map: ref(null),
      markers: ref([]),
      markerIcons:  {
        // eslint-disable-next-line no-undef
        "default": L.icon({
          iconUrl: '/svgs/red-pin.svg',
          iconSize: [20, 20],
          iconAnchor: [20, 20],
          popupAnchor: [-10, -26],
          shadowUrl: '/svgs/red-pin.svg',
          shadowSize: [20, 20],
          shadowAnchor: [20, 20]
        }),
      },
      filteringState: ref({
        ordering: 'DESC',
        key: null
      }),
      polling:null,

    }
  },
  mounted() {
    this.pollSensorData()
    this.$store.dispatch('user/getMarkerTemplate')
  },
  unmounted() {
    clearInterval(this.polling)

  },
  watch:{
    sensorShowingMeasurments: function(){
      this.$store.dispatch('user/updateMarkerTemplate', {sensorShowingMeasurments: this.sensorShowingMeasurments })
      this.reRenderPopups()
    },
    sensorShowingController: function (){
      this.$store.dispatch('user/updateMarkerTemplate', {sensorShowingController: this.sensorShowingController })
      this.reRenderPopups()
    },
    sensorShowingName: function (){
      this.$store.dispatch('user/updateMarkerTemplate', {sensorShowingName: this.sensorShowingName })
      this.reRenderPopups()
    },
    sensorShowingDescription: function (){
      this.$store.dispatch('user/updateMarkerTemplate', {sensorShowingDescription: this.sensorShowingDescription })
      this.reRenderPopups()
    },

  }

}
</script>

<style scoped>

#map{
  margin: 0;
  z-index: 1;
}

.content-header{
  margin-top:0;
}

.btn-brand{
  height: 40px;
  padding-top:0 !important;
  padding-bottom: 0 !important;
}

.col-3{
  width: 20%;
}
.col-9{
  width: 79.5%;
}

.leaflet-container {
  height: 70vh;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
}

.button-switch{
  margin-bottom: 15px;
  padding: 5px;
  background-color: var(--toggle-background);
  height: 40px;
  border-radius: 7px;
  font-size: 14px;
}

.button-switch img{
  height: 20px;
}

.button-switch button{
  background: transparent;
  border:0;
  padding: 5px 10px;
  border-radius: 7px;
}

.button-switch button.active-toggle{
  background: #FFFFFF;
  transition: 1s ease-out;
  color: var(--main-bg);
}



.action-buttons{
  position: relative;
}

.action-buttons button{
  border-radius: 5px;
  margin-right: 10px;
  background: var(--toggle-background)
}

.action-buttons button:not(.extra){
  padding: 8px;
}

.sensor-toolbar{
  position: absolute;
  top: 100%;
  z-index: 99999;
  right: 0;
  background: #fff;
  -webkit-box-shadow:0 16px 40px var(--drop-shadow-color);
  box-shadow: 0 16px 40px var(--drop-shadow-color);
  border-radius: 5px;
  width:240px;
}

.sensor-toolbar.toolbar-2{
  left: 0 !important;
}

.sensor-toolbar ul {
  list-style-type: none;
  padding: 10px;
  margin: 0;
}

.sensor-toolbar ul li {
  font-family: "TBCDinNusxuri-Medium";
  padding:10px;
  font-size: 14px;
}

.sensor-toolbar ul li label{
  padding-left: 5px;
}

.sensor-toolbar ul li img{
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.sensor-toolbar ul li:hover {
  background: var(--hover-item);
  border-radius: 5px;
  cursor: pointer;
}

.leaflet-popup{
  margin-bottom: -25px !important;
}

.table > :not(:first-child){
  border: 1px solid var(--border-color) !important;
}



.table{
  padding:20px;
  color: var(--text-sub-bold-color);
  text-align: center;
  vertical-align: middle;
}





.table tbody tr{
  line-height: 4px !important;
}

.table tbody tr:hover{
  background: var(--hover-item);
  cursor: pointer;
}


.table td:first-child, table th:first-child{
  padding-left: 20px;
}

.table tbody td{
  padding-top: 10px;
  padding-bottom: 10px;
  position: relative;
}

.sensor-name-span[contenteditable="true"] {
  background-color: #ffffff;
  border:1px solid var(--border-color)
}

.pencil-image{
  position: absolute;
  width: 15px;
  height: 15px;
}

.hover-overlay{
  position: absolute;
  top:15%;
  /*width: 0 !important;*/
  width: 40px !important;
  visibility: hidden;
  transition: .01s ease;
  transform: translate3d(-50%, 0, 0);
}

.hover-overlay-w {
  visibility: hidden;
}
.table tbody tr:hover .hover-overlay-w {
  visibility: visible;
}

.table tbody tr:active .hover-overlay-w {
  visibility: visible;
}

.table tbody tr:last-child{
  border: 1px solid var(--border-color) !important;
}

.table tbody tr:hover .hover-overlay  {
  /*width: 40px !important;*/
  visibility: visible;
  transition: .5s ease;
  transform: translate3d(0, 0, 0);
}


.btn-brand-chart{
  background-color: #FFFFFF;
  height: 30px;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.btn-brand-chart img{
  width: 100%;
  height: 20px;
}

.btn-add{
  height: 40px;
}

.empty-room-img-holder{
  border: 2px dashed var(--dropzone-border);
  padding-top: 10px;
  padding-bottom: 10px;
  cursor: pointer;
  color: var(--second-titles);
  background-color: #FFFFFF;
  height:70vh;
}



@media only screen and (min-width: 1198px) and (max-width: 1679px) {

  .sensor-toolbar ul li{
    font-size: 12px;
  }

  .sensor-toolbar ul li img{
    width: 18px;
    height: 18px;
  }
}


</style>

